import { useMutation } from "@tanstack/react-query"
import { useContentCache } from "./queries"
import {
	contentControllerChangeArchivedStatus,
	type SetArchivedDto,
} from "@/shared/api/generated"

export function useArchiveContentItem() {
	const contentCache = useContentCache()

	const formMutation = useMutation({
		mutationFn: (dto: SetArchivedDto) =>
			contentControllerChangeArchivedStatus(dto),
	})

	const handleArchive = async (id: string) => {
		await formMutation.mutateAsync({ id, setArchived: true })
		await contentCache.invalidateLibraryActivePage(true)
		await contentCache.invalidateLibraryArchivedPage()
	}

	const handleReturn = async (id: string) => {
		await formMutation.mutateAsync({ id, setArchived: false })
		await contentCache.invalidateLibraryActivePage()
		await contentCache.invalidateLibraryArchivedPage(true)
	}



	return { handleArchive, handleReturn, isLoading: formMutation.isPending }
}
